import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { initiales, nomComplet } from "./compte";

// Avatar du compte : la photo de profil si l'utilisateur en a une, sinon ses
// initiales (et aussi quand la photo ne se charge pas).
export const AvatarCompte = ({ user, photo }) => {
  const [erreur, setErreur] = useState(false);
  useEffect(() => setErreur(false), [photo]);
  return (
    <span className="menu-lateral__avatar" aria-hidden="true">
      {photo && !erreur ? <img src={photo} alt="" onError={() => setErreur(true)} /> : initiales(user) || "?"}
    </span>
  );
};

// Pied du menu : bouton compte (avatar, nom, société ou rôle) et son menu
// (Mon compte, Déconnexion, environnement hors production). Remplace l'avatar
// en tête de l'ancienne Sidenav et le bouton Déconnexion de la barre haute.
const CompteMenu = ({ user = {}, photo = null, libelleRole = "", badge = null, ouvert, onBasculer, onDeconnexion }) => {
  const refBouton = useRef(null);
  const nom = nomComplet(user);
  const societe = user.producer && user.producer.company;
  const sousTitre = societe || libelleRole;

  const surClavier = (evenement) => {
    if (evenement.key === "Escape" && ouvert && refBouton.current) refBouton.current.focus();
  };

  return (
    <div className="menu-lateral__pied" onKeyDown={surClavier}>
      <button
        ref={refBouton}
        type="button"
        className="menu-lateral__compte"
        aria-haspopup="true"
        aria-expanded={ouvert}
        aria-controls="menu-compte"
        onClick={onBasculer}
      >
        <AvatarCompte user={user} photo={photo} />
        <span className="menu-lateral__compte-texte">
          <span className="menu-lateral__compte-nom">{nom}</span>
          {sousTitre && <span className="menu-lateral__compte-role">{sousTitre}</span>}
        </span>
        <i className="fa fa-chevron-up" aria-hidden="true" />
      </button>
      <div id="menu-compte" className="menu-lateral__menu-compte" hidden={!ouvert}>
        <div className="menu-lateral__menu-compte-entete">
          <AvatarCompte user={user} photo={photo} />
          <div>
            <b>{nom}</b>
            {societe && <span className="menu-lateral__societe">{societe}</span>}
            {libelleRole && <span className="menu-lateral__role">{libelleRole}</span>}
          </div>
        </div>
        <Link to="/me">
          <i className="fa fa-user-circle" aria-hidden="true" />
          Mon compte
        </Link>
        <button type="button" onClick={onDeconnexion}>
          <i className="fa fa-power-off" aria-hidden="true" />
          Déconnexion
        </button>
        <div className="menu-lateral__env">
          <span>Perceval · Back-office</span>
          {badge && <span>Environnement : {badge.libelle}</span>}
        </div>
      </div>
    </div>
  );
};

export default CompteMenu;
